import { render, staticRenderFns } from "./EditScopeOfPracticeGroupModal.vue?vue&type=template&id=0ccdb1cc&scoped=true&"
import script from "./EditScopeOfPracticeGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditScopeOfPracticeGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdb1cc",
  null
  
)

export default component.exports